import classNames from 'classnames';
import React from 'react';
import UserIcon from 'src/components/UserIcon/UserIcon';
import { UserIconType } from 'src/utils/constants/User';
import styles from './CaseTab.module.scss';

interface TabProps {
  id: number;
  title: string;
  userIcon: UserIconType;
  isSelected?: boolean;
  onClickTab: (id: number) => void;
}

const CaseTab = ({ id, title, isSelected = false, userIcon, onClickTab }: TabProps) => {
  return (
    <div
      className={classNames(styles['case-tab__container'], { [styles['case-tab--selected']]: isSelected })}
      onClick={() => onClickTab(id)}
    >
      <UserIcon userIcon={userIcon} />
      <h5>{title}</h5>
    </div>
  );
};

export default React.memo(CaseTab);
